import React, { FC } from 'react';

import {
  makeStyles, Button, Box, Typography, List, TextField, ListItem,
} from '@material-ui/core';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';

const useStyles = makeStyles({
  label: {
    width: '8rem',
  },
  textField: {
    width: '10rem',
  },
});

interface CreateCatalogFormProps {
  word0: string,
  word1: string,
  word2: string,
  word3: string,
  word4: string,
}

const schema = yup.object().shape({
  word0: yup.string().required(),
  word1: yup.string().required(),
  word2: yup.string().required(),
  word3: yup.string().required(),
  word4: yup.string().required(),
});

interface CoverWordsEditorProps {
  catalogSpec: any,
  onUpdate: (words: string[]) => void,
}

const CoverWordsEditor: FC<CoverWordsEditorProps> = (props) => {
  const { catalogSpec, onUpdate } = props;
  const { handleSubmit, register, errors } = useForm<CreateCatalogFormProps>({
    validationSchema: schema,
  });
  const classes = useStyles();

  const onSubmit = (values: any) => {
    onUpdate([
      values.word0,
      values.word1,
      values.word2,
      values.word3,
      values.word4,
    ]);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <List>
        <ListItem>
          <Typography className={classes.label}>#1</Typography>
          <TextField
            required
            id="word0"
            name="word0"
            defaultValue={catalogSpec.featuredWords[0]}
            className={classes.textField}
            inputRef={register}
          />
          {errors.word1 && <Typography>{errors.word1}</Typography>}
        </ListItem>
        <ListItem>
          <Typography className={classes.label}>#2</Typography>
          <TextField
            required
            id="word1"
            name="word1"
            defaultValue={catalogSpec.featuredWords[1]}
            className={classes.textField}
            inputRef={register}
          />
          {errors.word1 && <Typography>{errors.word1}</Typography>}
        </ListItem>
        <ListItem>
          <Typography className={classes.label}>#3</Typography>
          <TextField
            required
            id="word2"
            name="word2"
            defaultValue={catalogSpec.featuredWords[2]}
            className={classes.textField}
            inputRef={register}
          />
          {errors.word2 && <Typography>{errors.word2}</Typography>}
        </ListItem>
        <ListItem>
          <Typography className={classes.label}>#4</Typography>
          <TextField
            required
            id="word3"
            name="word3"
            defaultValue={catalogSpec.featuredWords[3]}
            className={classes.textField}
            inputRef={register}
          />
          {errors.word3 && <Typography>{errors.word3}</Typography>}
        </ListItem>
        <ListItem>
          <Typography className={classes.label}>#5</Typography>
          <TextField
            required
            id="word4"
            name="word4"
            defaultValue={catalogSpec.featuredWords[3]}
            className={classes.textField}
            inputRef={register}
          />
          {errors.word4 && <Typography>{errors.word4}</Typography>}
        </ListItem>
      </List>
      <Box style={{ textAlign: 'left', paddingTop: '2rem' }}>
        <Button type="submit"><Typography variant="h6">Update</Typography></Button>
      </Box>
    </form>
  );
};

export default CoverWordsEditor;
